module.exports = __webpack_public_path__ + "img/ig.d6901668.svg";